import React, { useState } from "react";
import { Button, Alert, Modal, Result, Form, Input, Spin } from "antd";
import { useCheckMutation } from "../../redux/gemo/gemo";

function CheckGemo({ open, setOpen }) {
  const [idCheck, setIdCheck] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [check, { data, isLoading }] = useCheckMutation();
  const msg =
    data?.list?.finished === true
      ? "Sizning arizangiz muvafaqiyatli bajarilgan"
      : "Arizangiz jarayonda";

  const onFinish = async (values) => {
    setIdCheck(values.id);
    await check({ code: values.id });
    await isLoading;
    setIsModalOpen(true);
    setOpen(false);
  };
  const handleOK = () => {
    setIsModalOpen(false);
    setOpen(false);
  };
  const onClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Modal
        title=""
        open={isModalOpen}
        closeIcon={<></>}
        okButtonProps={{
          hidden: true,
        }}
        cancelButtonProps={{
          hidden: true,
        }}
      >
        <div className="check-msg">
          <h2>{`Sizning ${idCheck} sonli arizangiz:`}</h2>
          <div className="check-msg__alert">
            <Alert
              message={
                <p className={data?.list?.finished === true ? "suc" : "er"}>
                  {msg}
                </p>
              }
              type={data?.list?.finished === true ? "success" : "error"}
              description={
                data?.list?.finished === true ? (
                  <p className="check-msg__msgmessage">
                    Bajarilgan ish: {data?.list?.doneWork}
                  </p>
                ) : (
                  ""
                )
              }
            />
          </div>
          <Button type="primary" key="console" onClick={handleOK}>
            Yopish
          </Button>
        </div>
      </Modal>

      <Modal
        title="Ariza holatini tekshirish"
        onCancel={onClose}
        closable={true}
        okButtonProps={{
          hidden: true,
        }}
        cancelButtonProps={{
          hidden: true,
        }}
        open={open}
      >
        <div className="check">
          <Spin spinning={isLoading} tip="Loading...">
            <Form
              className="check__form"
              name="basic"
              onFinish={onFinish}
              autoComplete="off"
              layout="vertical"
            >
              <Form.Item
                label="Ariza raqamini kirting"
                name="id"
                rules={[
                  {
                    required: true,
                    message: "Error!",
                  },
                ]}
              >
                <Input className="check__input" />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  Tekshirish
                </Button>
              </Form.Item>
            </Form>
          </Spin>
        </div>
      </Modal>
    </div>
  );
}

export default CheckGemo;
